<div class="card">
  <div class="col-12">
    <div class="card-header customSmallHeader   rounded-0 fw-bold d-flex">
      <div class="col-4">
        <i class="fa fa-info me-2"></i> <b>Privacy Policy</b>
      </div>
    </div>
    <div class="card-body row">


      <p class="control-label">
        Quotator360.com is a Software provided by Munich Re Underwriting Agents (DIFC) Limited (‘MRUA’), and
        MRUA will retain all interest in and to the Software, including all documentation, modifications,
        improvements, upgrades, derivative words, and all other Intellectual Property rights in connection
        with the Software, including MRUA's (and affiliates) name, logos. and trademarks reproduced through
        the Service.
      </p>
    </div>

  </div>

  <br />

  <div class="col-12">
    <div class="card-header customSmallHeader   rounded-0 fw-bold d-flex">
      <div class="col-4">
        <i class="fa fa-info me-2"></i><b>Information Quotator receives from you</b>
      </div>
    </div>
    <div class="card-body row">
      <p class="control-label">
        You provide certain personally identifiable information (such as your name and email address) to
        Quotator when you register for an account or correspond with us.
      </p>
    </div>
  </div>
  <br />
  <div class="col-12">
    <div class="card-header customSmallHeader   rounded-0 fw-bold d-flex">
      <div class="col-4">
        <i class="fa fa-info me-2"></i><b>Cookie Policy </b>
      </div>
    </div>
    <div class="card-body row">
      <p class="control-label">
        A cookie is a small piece of data sent from website and stored on the user's computer by the
        user's web browser while the user is browsing.
        Cookies were designed to be a reliable mechanism for websites to remember stateful information
        or to record the user's browsing activity.
        Like many websites, we use cookies and similar technologies to collect additional website usage
        data and to operate our
        services.However,Some of our services may not function properly if you disable cookies.When your
        browser or device allows it, we use both session cookies and persistent cookies to better
        understand by the website how you interact with our services.
      </p>

    </div>
  </div>
  <br />
  <div class="col-12">
    <div class="card-header customSmallHeader   rounded-0 fw-bold d-flex">
      <div class="col-4">
        <i class="fa fa-info me-2"></i><b>Browser Local Storage Policy </b>
      </div>
    </div>
    <div class="card-body row">
      <p class="control-label">
        A local storage is a file created by a website in your device. Cookies are just one type of
        local storage, but there are others. It is important that you know them so you can block
        them or delete the data stored by them:

        Browser local storage. our websites use the browser's "sessionStorage" and "localStorage"
        to store data "sessionStorage" is stored temporarily, but the “localStorage” is persistent when you enables
        remember me in login page.
        This storage will be erased when you log-out from Quotator360 website or you may erase them by deleting your
        browser's history.
      </p>
    </div>
  </div>
</div>